import { defaultCss as bootstrapCss } from "../plugins/themes/bootstrap-integration/cssbootstrap";
import { defaultCss as bootstrapMaterialCss } from "../plugins/themes/bootstrap-material-integration/cssbootstrapmaterial";
export * from "../plugins/themes/bootstrap-integration/theme-settings";
export * from "../plugins/themes/bootstrap-material-integration/theme-settings";

export var defaultBootstrapCss = bootstrapCss;
export var defaultBootstrapMaterialCss = bootstrapMaterialCss;